// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Ylgp+","styled_div":"styles_styled_div__ascFF"};